import { useAuth } from '@/contexts/auth-context';
import { useRef } from 'react';
import { BillingTargetChangedError, useBillingActionScope } from './use-billing-action-scope';

/** A role change also discards settings read by the same actor and brand. */
export function useBillingSettingsScope() {
  const { user } = useAuth();
  const billing = useBillingActionScope();
  const scope = {
    ...billing.scope,
    role: user?.role ?? null,
    brandRole: user?.currentBrandRole ?? null,
  };
  const current = useRef(scope);
  current.current = scope;
  const assertCurrent = (target: typeof scope) => {
    billing.assertCurrent(target);
    if (target.role !== current.current.role || target.brandRole !== current.current.brandRole)
      throw new BillingTargetChangedError('Billing role changed');
  };
  return { scope, assertCurrent };
}

export type BillingSettingsScope = ReturnType<typeof useBillingSettingsScope>['scope'];
